module.exports = __webpack_public_path__ + "static/img/255.8ebf4776.png";